import { getUserCompanyList } from '@/common/js/util';
// 表单字段
export const searchFormColumns = (ctx) => {
  return [
    {
      name: '园区公司',
      prop: 'parkCompanyNo',
      type: 'select',
      options: getUserCompanyList(),
      changeMethod: 'changeMethod',
    },
    {
      name: '园区部门',
      prop: 'parkDepartmentNo',
      type: 'select',
      options: ctx.departList,
      clearable: true,
      filterable: true,
      disabled: !ctx.query.parkCompanyNo,
    },
    {
      name: '质权方名称',
      prop: 'pledgeeNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      changeMethod: 'changeMethod',
    },
    {
      name: '出质方名称',
      prop: 'pledgorNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      changeMethod: 'changeMethod',
    },
    {
      type: 'select',
      name: '合同性质',
      prop: 'contractNature',
      options: ctx.contractNatureList,
    },
    {
      type: 'input',
      name: '合同编号',
      prop: 'contractNo',
      placeholder: '请输入合同编号',
    },
    {
      type: 'select',
      name: '合同状态',
      prop: 'contractStatus',
      options: ctx.contractStatusList,
    },

    {
      prop: 'contractValidFrom',
      name: '开始日期',
      type: 'startDaterangePicker',
    },
    {
      prop: 'contractValidUntil',
      name: '结束日期',
      type: 'endDaterangePicker',
    },
    {
      prop: 'goodsType',
      name: '货物类型',
      type: 'searchTableSpec',
      searchType: 'productType',
      isMultiple: true,
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      currentValue: ctx.query.goodsTypeName,
      changeMethod: 'changeMethod',
    },
    // {
    //   prop: 'goodsCategory',
    //   name: '货物品类',
    //   type: 'searchTableSpec',
    //   searchType: 'goodsDetail',
    //   isMultiple: true,
    //   changeMethod: 'changeMethod',
    // },
    {
      prop: 'storageCompanyNo',
      name: '仓库公司',
      type: 'searchTableSpec',
      searchType: 'warehouseCompany',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'storageNo',
      name: '仓库名称',
      type: 'searchTableSpec',
      searchType: 'warehouse',
      extraData: {
        companyCode: ctx.userInfo.companyCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'paperContractNo',
      name: '纸质合同号',
      type: 'input',
    },
  ];
};

// 表格字段
export const baseColumnListDefault = [
  { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
  {
    field: 'pledgeeName',
    title: '质权方名称',
    width: 120,
  },
  {
    field: 'pledgorName',
    title: '出质方名称',
    width: 120,
  },
  {
    field: 'relatedName',
    title: '关联方名称',
    width: 120,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    width: 120,
  },
  {
    field: 'paperContractNo',
    title: '纸质合同号',
    width: 120,
  },
  {
    field: 'contractStatus',
    title: '合同状态',
    width: 120,
  },
  {
    field: 'signDate',
    title: '签约日期',
    width: 120,
  },
  {
    field: 'signPerson',
    title: '签约人',
    width: 120,
  },
  {
    field: 'contractValidFrom',
    title: '服务开始日期',
    width: 120,
  },
  {
    field: 'contractValidUntil',
    title: '服务结束日期',
    width: 120,
  },
  {
    field: 'storageCompanyName',
    title: '仓库公司',
    width: 120,
  },
  {
    field: 'storageName',
    title: '仓库名称',
    width: 120,
  },
  {
    field: 'goodsTypeName',
    title: '货物类型',
    width: 120,
  },
  {
    field: 'contractAmount',
    title: '合同金额',
    width: 120,
  },
  {
    field: 'receiveMoneyMethod',
    title: '收款方式',
    width: 120,
  },
  {
    field: 'receivedAmount',
    title: '已收款金额',
    width: 120,
  },
  {
    field: 'lastPaymemtTime',
    title: '上次收款时间',
    width: 120,
  },
  {
    field: 'paymentTimes',
    title: '收款次数',
    width: 120,
  },
  {
    field: 'remark',
    title: '备注',
    width: 120,
  },
];
